import { render, staticRenderFns } from "./InstitucionAudit.vue?vue&type=template&id=522e503b"
import script from "./InstitucionAudit.vue?vue&type=script&lang=js"
export * from "./InstitucionAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports